import type { Need } from "@shared/access/check";
import type { Needs, PageAccess } from "../auth/access";

const at = (needs: Needs): PageAccess => ({ needs, place: "page" });
const nenda = (needs: Need): PageAccess => ({ needs, place: "nenda" });

/** Read by each page's menu item and its route, so the two cannot drift. */
export const PAGE_ACCESS = {
  companies: nenda({ resource: "companies", level: "view" }),
  demoStudio: nenda({ resource: "demos", level: "view" }),
  salesVideos: nenda({ resource: "sales-videos", level: "view" }),
  roomTypes: nenda({ resource: "units", level: "administrate" }),
  clientErrors: nenda({ resource: "client-errors", level: "administrate" }),
  generalSettings: nenda({
    resource: "global-settings",
    level: "administrate",
  }),
  templateDefaults: nenda({ resource: "tv-layout", level: "administrate" }),
  radioStations: nenda({ resource: "tv-layout", level: "administrate" }),
  appCatalogue: nenda({ resource: "tv-layout", level: "administrate" }),
  globalMedia: nenda({ resource: "media", level: "administrate" }),
  distribution: nenda({ resource: "distribution", level: "administrate" }),
  contentAnalytics: nenda({
    resource: "distribution/titles",
    level: "administrate",
  }),
  users: nenda({ resource: "users", level: "view" }),
  ota: nenda({ resource: "software-updates", level: "administrate" }),

  signageOverview: at({ resource: "signage", level: "edit" }),
  fleetHealth: at({ resource: "screens", level: "view" }),
  deviceGroups: at({ resource: "screens", level: "view" }),
  healthAlerts: at({ resource: "screens/alerts", level: "view" }),
  meteredUsage: at({ resource: "licences/metered-usage", level: "view" }),

  placeDashboard: at({ resource: "premises", level: "view" }),
  placeScreens: at({ resource: "screens", level: "view" }),
  placeSettings: at({ resource: "premises", level: "administrate" }),
  placeProducts: at({ resource: "licences", level: "administrate" }),
  placeRooms: at({ resource: "units", level: "administrate" }),

  tvLayout: at({ resource: "tv-layout", level: "view" }),
  tvAppearance: at({ resource: "tv-layout", level: "administrate" }),
  tvLanguages: at({
    resource: "tv-layout/translations",
    level: "administrate",
  }),
  media: at({ resource: "media", level: "view" }),
  guestWeb: at({ resource: "guest-web", level: "view" }),

  offers: at({ resource: "offers", level: "view" }),
  guestRequests: at({ resource: "guest-requests", level: "view" }),
  revenue: at([
    { resource: "offers", level: "view" },
    { resource: "guest-requests", level: "view" },
  ]),

  residents: at({ resource: "residents", level: "view" }),
  videoCalls: at({ resource: "video-calls", level: "view" }),

  signage: at({ resource: "signage", level: "edit" }),
  signageTemplates: at({ resource: "signage-templates", level: "view" }),
  signageUpdates: at({ resource: "signage/slide-content", level: "edit" }),

  statistics: at({ resource: "statistics", level: "view" }),
  energy: at({ resource: "screens", level: "view" }),
} as const satisfies Record<string, PageAccess>;
